import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "validate-calculated-metrics"
    }}>{`Validate calculated metrics`}</h1>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Adobe may add optional request and response members (name/value pairs) to existing API objects at any time and without notice or changes in versioning. Adobe recommends that you refer to the API documentation of any third-party tool you integrate with our APIs so that such additions are ignored in processing if not understood. If implemented properly, such additions are non-breaking changes for your implementation. Adobe will not remove parameters or add required parameters without first providing standard notification through release notes.`}</p>
    <p>{`Data views have different dimensions and metrics available. A calculated metric that's valid in one data view might not be valid in another. You can use the `}<inlineCode parentName="p">{`calculatedmetrics/validate`}</inlineCode>{` endpoint to check and see if a given calculated metric is valid.`}</p>
    <p><inlineCode parentName="p">{`POST https://cja.adobe.io/calculatedmetrics/validate`}</inlineCode></p>
    <p>{`An example POST body:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "name": "Integration Test 1",
    "description": "Integration Test 1 Description",
    "dataId": "{DATAID}",
    "type": "percent",
    "definition": {
        "func": "calc-metric",
        "formula": {
            "func": "divide",
            "col1": {
                "func": "metric",
                "name": "metrics\\/visits"
            },
            "col2": {
                "func": "metric",
                "name": "metrics\\/visitors"
            }
        },
        "version": [
            1,
            0,
            0
        ]
    }
}
`}</code></pre>
    <p>{`An example response:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "valid": true,
  "identityMetrics": [ { "identity": "metrics/visits" }, { "identity": "metrics/visitors" } ],
  "functions": [ "divide" ],
  "validator_version": "1.0.0",
  "supported_products": [ "oberon", "frag" ],
  "supported_schema": [ "schema_oberon", "schema_frag" ]
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      